"use client";

import Footer from "../global/partials/Footer";
import CompetitorHeader from "../pageComponents/competitor/CompetitorHeader";
import CompetitorHero from "../pageComponents/competitor/CompetitorHero";
import WhyChangeSection from "../pageComponents/competitor/WhyChangeSection";
import FounderSection from "../pageComponents/competitor/FounderSection";
import SwitchSection from "../pageComponents/competitor/SwitchSection";
import NewPricingSection from "../pageComponents/newPricing/NewPricingSection";
import TeamSection from "../pageComponents/home/TeamSection";
import CertificateSectionV2 from "../pageComponents/global/sections/CertificateSectionV2";
import TestimonialsSectionV2 from "../pageComponents/global/sections/TestimonialsSectionV2";
import FaqSection from "../pageComponents/global/sections/FaqSection";
import ScrollingBanner from "../pageComponents/global/ScrollingBanner";
import { measuredRichTextForest } from "../pageComponents/patrickAffiliate/richtext";
import { PageHomeSchema } from "@/sanity/pages/PageHomeTemplate";
import { PageCompetitorSchema } from "@/sanity/pages/PageCompetitorTemplate";
import { DEFAULT_LANGUAGE } from "@/sanity/globals/I18n";

export default function PageCompetitorJSX({ data }: { data: PageCompetitorSchema }) {
  const language = data.settings?.language ?? DEFAULT_LANGUAGE;

  return (
    <main className="flex flex-col items-center bg-[#fbfbfb]">
      <CompetitorHeader data={data} />
      <CompetitorHero data={data} />
      <WhyChangeSection data={data} />
      {(data.pricingSectionV3 || data.pricingSectionV2) && (
        <NewPricingSection
          section={data.pricingSectionV2}
          sectionV3={data.pricingSectionV3}
          language={language}
          sectionClassName="max-lg:pt-[7rem] max-lg:pb-[9rem]"
        />
      )}
      <TeamSection
        data={data as unknown as PageHomeSchema}
        language={language}
        className="bg-[#fbfbfb] max-lg:pt-[7rem] max-lg:pb-[8rem] max-lg:[&>div]:gap-[5rem]"
      />
      <CertificateSectionV2
        compactMobile
        data={{
          chip: data.certificateChip,
          avatarImages: data.certificateAvatarImages,
          title: data.certificateTitle,
          text: data.certificateText,
          highlightedText: data.certificateHighlightedText,
          images: data.certificateImagesRefs
            ?.map((c) => c.image)
            .filter((img): img is NonNullable<typeof img> => Boolean(img)),
          ctaUrl: data.certificateCtaUrl,
        }}
        language={language}
      />
      <TestimonialsSectionV2
        compactMobile
        className="max-lg:pb-[5.5rem] lg:pt-[10rem]"
        language={language}
        theme="dark"
        data={{ ...data, testimonialsCards: data.testimonialsCardsRef }}
      />
      <div className="w-full bg-[#001B14] pb-[1.25rem] lg:hidden">
        <ScrollingBanner
          theme="dark"
          className="border-y-0 bg-transparent"
          words={data.scrollingWords?.words}
          wordsI18n={data.scrollingWords?.wordsI18n}
        />
      </div>
      <FounderSection data={data} />
      <SwitchSection data={data} />
      <FaqSection
        data={data}
        defaultOpenFirst
        titleComponents={measuredRichTextForest}
        className="bg-[#fbfbfb] pt-[8rem] lg:pt-[15rem] [--hl-wash:4.5rem] lg:[--hl-wash:5.75rem] [--hl-tracking:-0.03em] [&_h2_span]:leading-[0]"
      />
      {data.settings?.footer && (
        <Footer data={data.settings.footer} finalCta={data} language={language} />
      )}
    </main>
  );
}
